<p>
  angular-grid-sample works!
</p>
